export default "__VITE_ASSET__CO$kGXzk__"